export default {
	liveCardCheck:'View more',
	home: 'Home',
	prefix: '/en/',
	tel: 'Tel',
	email: 'Email',
	more: 'More',
	share: 'Share',
	dicKey: 'value',
	enumKey: 'english',
	submit: 'Submit',
	cancel: 'Cancel',
	language: 'Language',
	confirm: 'Confirm',
	welcome: 'Welcome to the Fifth International Commercial & Legal Cooperation Forum',
	welcomeNoTime: 'International Commercial Legal Cooperation Forum',
	introduce: 'More Details',
	location: 'Location',
	aboutUs: 'About Us',
	previousForums: 'Previous Forums',
	privacy: 'Privacy Policy',
	aboutForum: 'About ICLCF',
	contactUs: 'Contact Us',
	enterRoom: 'Watch now',
	watchNow: 'Watch Now',
	loadMore: 'Load More',
	enrollNow: 'Enroll Now',
	views: 'Views',
	backTop: 'Back to Top',
	videoViewNumber: ' Viewers',
	successUpload: 'successfully upload!',
	uploadImgError: 'Image format error',
	uploadImgSizeError: 'The maximum image size cannot exceed 2MB',
	countdown: {
		still: 'Countdown',
		title: 'Countdown to the Fifth Forum Opening Ceremony',
		watchNow: 'Watch Live Now',
		OfficiallyOpened: 'Officially opened',
		liveTime: 'Live Date',
		Countdown: 'Count Down',
		opening: 'The Fifth International Commercial & Legal Cooperation Forum',
		format: {
			day: 'DAYS',
			hour: 'HRS',
			minute: 'MINS',
			second: 'SECS',
			text: '<span>Days</span><span>Hours</span><span>Minutes</span><span>Seconds</span>'
		}
	},
	im: {
		send: 'Send',
		header: 'A Grand Gathering for Global Commercial and Legal Discussion and Collaboration',
		// header: 'The curtain is now raised for a grand gathering for global commercial and legal discussion and collaboration',
		placeholder: 'Please enter your message....'
	},
	actionSide: {
		chat: 'Online<br>Service',
		enrollNow: 'Online Registration',
		offlineEnrollNow: 'Offline Registration',
		onlineSide: "Online Registration",
		offlineSide: "Offline Registration",
		feedback: 'Feedback',
		contactUs: 'Contact Us',
		applyPath: '/en/apply'
	},
	qrcode: {
		lawback: 'International Legal Service Platform',
		ICLCF: 'International Commercial & Legal Cooperation Forum'
	},
	interview: {
		all: 'All',
		latest: 'Latest',
		text: 'Specialists Interview'
	},
	live: {
		all: 'All Live',
		time: 'Time',
		agenda: 'Agenda',
		replay: 'Replay',
		back: 'Back to list',
		conference: 'Conference Live',
		introduction: 'Introduction',
		over: 'The live is over',
		views: 'Views',
		viewLive: 'View Live',
		clickLive: 'Click to watch Live',
		wait: 'Live is about to start<br/>Please wait...',
		'chat': 'Interact with us',
		'guest': 'Guests Introduction',
		'forbiddenTime': 'You are banned to post for 5 mins',
		'hasForbidden': 'You have been banned to post ',
		'talk': 'Join us to share your views...',
		'youAreDisabled': 'You have been banned and cannot send messages now',
		'enterWord': 'Enter your words',
		'send': 'Send',
		'remindTime': 'Live Start in',
		'applyNum': 'People Reserved',
		'watchNum': 'Viewers',
		'proTalk': 'Exclusive Interviews',
		'lookMore': 'View more',
		'forbid': 'banned to post for 5 mins',
		'forbidEver': 'banned to post until Live ends',
		'unForbid': 'removed from banned ',
		'liveEnd': 'Live ends',
		'remove': 'remove',
		"flash": "Flash Player for playing video files",
		"willStart": "The live broadcast will start soon",
		"netError": "network abort",
		"d": 'DAYs',
		"h": 'HRs',
		"m": 'MINs',
		"s": 'SECs'

	},
	guest: {
		all: 'All Guests',
		ranking: 'In no particular order',
		introduction: 'Guests Introduction'
	},
	agenda: {
		am: 'Morning Agenda',
		pm: 'Afternoon Agenda',
		all: 'All Agendas',
		text: 'Forum Agendas',
		expand: 'More Guests',
		collapse: 'Collapse'
	},
	news: {
		tag: 'Tags',
		hot: 'Latest Updates',
		allNews: 'All Information',
		latest: 'Latest News',
		category: 'Category',
		recommend: 'Recommend',
		views: 'Views'
	},
	links: {
		text: 'Special Acknowledgement',
		ranking: 'The names are not listed in order',
		recommendation: 'Project Recommendation',
		supplier: 'Quality Supplier',
		supplierRec: 'Quality Supplier Recommendation',
		publisher: 'Publisher'
	},
	video: {
		outline: 'Outline',
		content: 'Content',
		recommend: 'Recommend',
		expert: 'Expert Introduction',
		copyright: 'All rights reserved All materials not authorized may not be redirected or for other usages.',
		PastVideo: 'Previous Highlights',
		LectureTour: 'Lecture Tour',
		Introduction: 'Introduction'
	},
	search: {
		text: 'Search',
		latest: 'Latest News',
		guest: 'Guest',
		video: 'Specialists Interview',
		agenda: 'Agenda',
		placeholder: 'Search',
		noResult: 'No Result',
		searchNull: 'You are advised to modify the keyword and try again'
	},
	comment: {
		top: 'Top',
		send: 'Send',
		text: 'Interact',
		all: 'All Interacts',
		none: 'No Interacts',
		placeholder: 'Say Something...'
	},
	login: {
		btn: 'Login',
		path: '/en/login',
		text: 'Forum Log in',
		verifyAlert: 'Verification code sent',
		submit: 'Login',
		rememberMe: 'Remember Me',
		Logout: 'Log Out',
		agreement: 'I have read and agree to<br><a href="/en/privacy" style="color: #646C7A">Service Agreement</a> and <a href="/en/privacy" style="color: #646C7A">Privacy Policy</a>.',
		tabs: [{
			key: 'password',
			tab: 'Password',
			type: 'login',
			active: true,
			rules: ['username', 'password'],
			inputs: ['username', 'password']
		}, {
			key: 'captcha',
			tab: 'Captcha',
			type: 'login',
			rules: ['username', 'code'],
			inputs: ['username', 'code']
		}, {
			key: 'email',
			tab: 'Email',
			type: 'signup',
			active: true,
			rules: ['email', 'code', 'password'],
			inputs: ['email', 'code', 'password', 'actualName', 'company', 'phone']
		}, {
			key: 'mobile',
			tab: 'Mobile',
			type: 'signup',
			rules: ['phone', 'code', 'password'],
			inputs: ['phone', 'code', 'password', 'actualName', 'company', 'email']
		}, {
			key: 'mobile',
			tab: 'Mobile',
			type: 'forget',
			active: true,
			rules: ['phone', 'code', 'password'],
			inputs: ['phone', 'code', 'password']
		}, {
			key: 'email',
			tab: 'Email',
			type: 'forget',
			rules: ['email', 'code', 'password'],
			inputs: ['email', 'code', 'password']
		}],
		rules: {
			username: [{ required: true, whitespace: true, message: 'Please enter your mobile number or email address' }],
			phone: [{ required: true, whitespace: true, pattern: /^((?!@).)*$/, message: 'Please enter your valid mobile number' }],
			email: [{ required: true, whitespace: true, pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: 'Please enter your valid email' }],
			code: [{ required: true, whitespace: true, message: 'Please enter the verification code' }],
			password: [{ required: true, message: 'Please enter the password' }],
			actualName: [{ required: true, whitespace: true, message: 'Please enter your name' }],
			company: [{ required: true, whitespace: true, message: 'Please enter company name' }]
		},
		inputs: {
			username: { icon: 'mobile', type: 'a-input', placeholder: 'Phone number/ Email' },
			phone: { icon: 'mobile', type: 'a-input', placeholder: 'Mobile', extra: 'Only Chinese mobile can be registered' },
			email: { icon: 'mail', type: 'a-input', placeholder: 'Email' },
			code: { icon: 'safety', type: 'a-input', placeholder: 'Captcha', append: { text: 'Send' } },
			password: { icon: 'lock', type: 'a-input-password', placeholder: 'Password' },
			actualName: { icon: 'user', type: 'a-input', placeholder: 'Name' },
			company: { icon: 'bank', type: 'a-input', placeholder: 'Company name （Optional）' },
			phoneEmail: { error: 'Please enter correct phone number and Email' }
		}
	},
	forget: {
		text: 'Forgotten Password',
		remember: 'Remember the password? Go to login'
	},
	signup: {
		text: 'Sign Up',
		expand: 'More information',
		collapse: 'Hidden information',
		hasAccount: 'Already have an account? Go to login'
	},
	logout: {
		title: 'Log out',
		content: 'Confirm logout?'
	},
	profile: {
		btn: 'Me',
		path: '/en/profile',
		profile: {
			tab: 'View Profile',
			mobile: 'Mobile Number',
			company: 'Company',
			email: 'Email',
			setPwd: 'Set Password',
			changePwd: 'Change Password',
			logout: 'Log out'
		},
		message: 'Message',
		appointment: {
			tab: 'My Appointment',
			no: 'NO',
			guest: 'Guest',
			time: 'Time',
			tools: 'Tools',
			content: 'Content',
			duration: 'Duration',
			talkType: 'Negociation Types',
			company: 'Company Name',
			position: 'Position',
			enterpriseScale: 'Company\'s annual Production Value'
		}
	},
	appointment: {
		btn: 'Appointment',
		title: 'Speakers Appointment',
		message: 'Please wait patiently and make your communication channels open, our relevant staff will contact you within 3 working days.',
		fields: {
			content: {
				label: 'Negotiation Content',
				placeholder: 'Enter Content',
				help: 'Maximum 1024 characters'
			},
			utc: 'World Time',
			time: 'Appointment Time',
			way: {
				label: 'Tools'
			},
			contact: {
				label: 'Contact',
				placeholder: 'Enter Contact'
			},
			talkType: 'Negociation Types',
			company: {
				label: 'Company Name',
				placeholder: 'Enter Company Name'
			},
			position: {
				label: 'Position',
				placeholder: 'Enter Your Position'
			},
			enterpriseScale: 'Company\'s annual Production Value',
			submit: 'Submit'
		},
		rules: {
			way: [{ required: true, message: 'Please select' }],
			time: [{ required: true, message: 'Please select time' }],
			contact: [{ required: true, whitespace: true, message: 'Please enter contact' }],
			content: [{ required: true, whitespace: true, message: 'Please enter content' }],
			company: [{ required: true, whitespace: true, message: 'Please enter company name' }],
			position: [{ required: true, whitespace: true, message: 'Please enter your position' }]
		}
	},
	enroll: {
		text: 'Enroll Now',
		message: 'Success',
		inputs: {
			inviterId: {
				label: 'Inviter',
				type: 'a-select',
				placeholder: 'Select Inviter',
				rules: [{ required: true, whitespace: true, message: 'Please select a inviter' }]
			},
			attendee: {
				label: 'Attendee',
				type: 'a-select',
				placeholder: 'Select Attendee',
				rules: [{ required: true, whitespace: true, message: 'Please select a attendee' }]
			},
			company: {
				label: 'Company',
				type: 'a-input',
				placeholder: 'Enter Company',
				rules: [{ required: true, whitespace: true, message: 'Please enter company name' }]
			},
			name: {
				label: 'Name',
				type: 'a-input',
				placeholder: 'Enter Name',
				rules: [{ required: true, whitespace: true, message: 'Please enter your name' }]
			},
			position: {
				label: 'Position',
				type: 'a-input',
				placeholder: 'Enter Position',
				rules: [{ required: true, whitespace: true, message: 'Please enter your position' }]
			},
			email: {
				label: 'Email',
				type: 'a-input',
				placeholder: 'Enter Email Address',
				rules: [{ required: true, whitespace: true, message: 'Please enter your email address' }]
			},
			mobile: {
				label: 'Mobile Number',
				type: 'a-input',
				placeholder: 'Enter Mobile Number',
				rules: [{ required: true, whitespace: true, message: 'Please enter your mobile number' }]
			}
		}
	},
	feedback: {
		text: 'Feedback',
		message: 'Thank you for your feedback',
		inputs: {
			name: {
				label: 'Name',
				type: 'a-input',
				placeholder: 'Enter Name',
				rules: [{ required: true, whitespace: true, message: 'Please enter your name' }]
			},
			mobile: {
				label: 'Mobile Number',
				type: 'a-input',
				placeholder: 'Enter Mobile Number',
				rules: [{ required: true, whitespace: true, message: 'Please enter your mobile number' }]
			},
			content: {
				label: 'Content',
				type: 'a-textarea',
				placeholder: 'Enter Content',
				help: 'Maximum 200 characters',
				rules: [{ required: true, whitespace: true, message: 'Please enter the content' }]
			}
		}
	},
	footer: {
		email: 'Email',
		support: 'Service Support: <a href="https://www.lawback.com/" target="_blank">Lawback</a>',
		suggest: 'Please use Chrome or IE9 and above browsers with 1280*1024 and above resolution for better experience.',
		links: [{
			text: 'About ICLCF',
			path: '/en/about'
		}, {
			text: 'Contact Us',
			path: '/en/contact'
		},
		// 	{
		// 	text: 'Links',
		// 	path: '/en/links?types=1,2'
		// },
		{
			text: 'Privacy Policy',
			path: '/en/privacy'
		}],
		relation: ['Hotline', '0731-88665003 / 010-82217083', 'Email', 'ccpit_2021@163.com'],
		erwei1: 'International Commercial & Legal Cooperation Forum',
		erwei2: 'International Legal Service Platform'
	},
	searchTabs: ['Live', 'Speakers', 'Exclusive Interviews', 'Highlights ', 'News', 'The Organization'],
	offlineApply: {
		lastStep: 'Back',
		nextStep: 'Next',
		confirm: 'Confirm',
		getBack: 'Back to revise',
		submit: 'Submit',
		applyPlan: ['Personal Information', 'Institutional Information', 'Contact Information'],
		baomingxinxitianxie: 'Registration Information',
		gerenxinxi: 'Personal information',
		jigouxinxi: 'Institutional information',
		lianxixinxi: 'Contact information',
		leixing: 'Categories',
		nameCn: 'Name (Chinese)',
		nameEn: 'Name (English)',
		qianfaguojia: 'Issuing country or region',
		shenfenzhengleixing: 'ID type',
		zhengjianhaoma: 'ID number',
		chushengriqi: 'Date of Birth',
		sex: 'Gender',
		chengwei: 'Title',
		touxiang: 'Image upload',
		zhengjianshangchuan: 'Certificate upload',
		qingxuanze: 'Please select',
		nameEnPlaceholder: 'Please input your English name',
		nameCnPlaceholder: 'Please input your Chinese name',
		zhengjianPlaceholder: 'Please input your ID number',
		leixingRules: 'Please select Categories',
		qianfaguojiaRules: 'Please select Issuing country or region',
		shenfenzhengleixingRules: 'Please select ID type',
		chushengriqiRules: 'Please select Date of Birth',
		sexRules: 'Please select Gender',
		chengweiRules: 'Please select Title',
		touxiang: 'Image Upload',
		zhengjianshangchuan: 'Certificate Upload',
		chushengriqiRules: 'Please select date of birth',
		sexRules: 'Please select gender',
		chengweiRules: 'Please select title',
		zhengjianhaomaRules: 'Please input your ID number',
		ImageUploadHint: {
			p1: 'The uploaded images/photos should be the recent bareheaded front ID photo with PNG/JPG/JPEG. format',
			p2: 'No more than 2M memory of resolution by 600px*800px.',
			p3: 'Don’t upload images of other formats by modifying the file’s extension name.',
			p4: 'Keep the image with good definition.',
			rules: 'Please upload your avatar.'
		},
		CertificateUploadHint: {
			p1: 'Upload the certificate as a photo or attachment, and the format should be png/jpg/jpeg/pdf',
			p2: 'The memory should be within 2M',
			p3: 'Don’t upload images of other format by modifying the file’s extension name.',
			p4: 'Keep the image with good definition.',
			rules: 'Please upload your credentials'
		},
		hangye: 'Select Industry',
		jigouEn: 'Company Full Name (English)',
		zhiwuCn: 'Position (Chinese)',
		jigoujianchengCn: 'Company Short Name (Chinese)',
		jigouCn: 'Company Full Name (Chinese)',
		jigoudizhi: 'Company Address',
		zhiwuEn: 'Position (English)',
		jigoujianchengEn: 'Company Short Name (English)',
		jigouCnRules: 'Please input company full name (Chinese)',
		jigouEnRules: 'Please input company full name (English)',
		jigoudizhiRules: 'Please input your company address',
		zhiwuCnRules: 'Please input position (Chinese)',
		zhiwuEnRules: 'Please input position (English)',
		jigoujianchengCnRules: 'Maximum 8 characters',
		jigoujianchengEnRules: 'A maximum of 20 letters including Spaces',
		hangyeRules: 'Please select industry',
		lianxidianhua: 'Telephone No.',
		chuanzhen: 'Fax No.',
		LianXiRenZhiWu: 'Contacts Position',
		LianXiRenEmail: 'Contacts Email',
		ChePaiHao: 'License Plate No.',
		AddChePaiHao: 'Add License Plate No.',
		LianLuoXinxiWhetherPublic: 'If You Agree to Open Your Contacts Information to Public',
		BeiZhu: 'Notes',
		emil: 'E-mail',
		LianXiRenName: 'Contacts Name',
		LianXiRenPhone: 'Contacts Telephone No.',
		YouBian: 'Postcode',
		TongXun: 'Instant Messaging',
		WhetherInterview: 'If You Agree to be Interviewed',
		yes: 'Yes',
		no: 'No',
		lianxidianhuaRules: 'Please input your phone',
		emilRules: 'Please input your e-mail',
		chuanzhenRules: 'Please input fax No.',
		LianXiRenNameRules: 'Please input contacts name',
		LianXiRenZhiWuRules: 'Please input contacts position',
		LianXiRenPhoneRules: 'Please input contacts telephone No.',
		LianXiRenEmailRules: 'Please input contacts email',
		YouBianRules: 'Please input postcode',
		ChePaiHaoRules: 'Attention: Please don’t mix up “0” and “O”, and any error will not work normally.',
		TongXunRules: 'A maximum of 200 words',
		phoneRulesError: 'The format of the phone number is incorrect',
		emilRulesError: 'The email format is incorrect',
		infoConfirm: 'Confirm Information',
		submitPrompt: 'Please review your information carefully before submit and any modification is not allowed after submitted',
		Review: 'Review',
		ConfirmSubmit: 'Confirm to Submit',
		applySuccess: 'Submitted Successfully!',
		jigoujianchengCnRulesNull: 'Please input company short name (Chinese)',
		jigoujianchengEnRulesNull: 'Please input company short name (English)',
		shenfenzhengError: 'Wrong id card format',
		zhengwentabs: ['Essay Writing Competition'],

		"viwers": "Viewers",
		"noMore": "No More Content",
		"type": "Categories",
		"nameCn_tips": "Please input your chinese name",
		"nameEn_tips": "Please input your english name",
		"nameEn_tips1": "Please input your english name  (if no, please fill in None)",
		"area": "Issuing country or region",
		"address_tip": "Please enter detailed address",
		"address_tip2": "Please enter your street",
		"cerType": "ID type",
		"cerCode": "ID number",
		"cerCode_tips": "Please input your ID number",
		"cerCode_tips2": "your ID number invalid",
		"birth": "Date of Birth",
		"date_tips": "Please select",
		"nick": "Title",
		"head": "Image upload",
		"idCard": "Certificate upload",
		"mod_1": "Personal information",
		"mod_2": "Institutional information",
		"mod_3": "Contact information",
		"industry": "Select Industry",
		"select_tips": "Please select",
		"orgCn": "Company Full Name (Chinese)",
		"orgCn_tips": "Please input company full name (Chinese)",
		"orgEn": "Company Full Name (English) ",
		"orgEn_tips": "Please input company full name (English)",
		"orgEn_tips1": "Please input company full name (English) (if no, please fill in None)",
		"orgAddr": "Company Address",
		"orgAddr_tips": "Please input company address",
		"orgAddr_tips1": "Please input company address (if no, please fill in None)",
		"position": "Position",
		"position_tips": "Please input position",
		"positionEn": "Position (English)",
		"positionEn_tips": "Please input position (English)",
		"orgSimpleCn": "Company Short Name (Chinese)",
		"orgSimpleCn_tips": "8 letters at most",
		"orgSimpleEn": "Company Short Name (English)",
		"orgSimpleEn_tips": "A maximum of 20 letters (spaces included)",
		"phone": "Telephone No.",
		"phone_tips": "Please input telephone No.",
		"phone_tips2": "Telephone No. invalid",
		"email": "E-mail Address",
		"email_tips": "Please input e-mail address",
		"email_tips2": "E-mail address invalid",
		"fax": "Fax No.",
		"fax_tips": "Please input fax No.",
		"iName": "Contacts Name",
		"iName_tips": "Please input contacts name",
		"iPosition": "Contacts Position",
		"iPosition_tips": "Please input contacts position",
		"iPhone": "Contacts Telephone No.",
		"iPhone_tips": "Please input contacts telephone No.",
		"iEmail": "Contacts Email",
		"iEmail_tips": "Please input contacts email",
		"postcode": "Postcode",
		"postcode_tips": "Please input postcode",
		"plate": "License Plate No.",
		"plate_tips": "Attention: Please don’t mix up “0” and “O”, and any error will not work normally.",
		"plate_tips2": "License plate No. invalid",
		"plateAdd": "Add",
		"plateRemove": "Remove",
		"im": "Instant Messaging",
		"im_tips": "200 letters at Most",
		"open": " If you agree to open your contacts information to public",
		"interview": "If you agree to be interviewed",
		"remarks": "Notes",
		"prev": "Back",
		"next": "Next",
		"yes": "Yes",
		"no": "No",
		"ok": "Confirm",
		"back": "Back to revise",
		"submit": "Submit",
		"confirm": "Confirm to Submit",
		"confirm2": "Submit",
		"confirm_tips": "Please review your information carefully before submit and any modification is not allowed after submitted",
		"check": "Review",
		"success": "Submitted Successfully!",
		"uploadSuccess": "Upload Success！",
		"uploadFailed": "Upload Failed！",
		"upload_tips": "Please upload",
		ConfirmSubmit: 'Confirm to Submit ',
		submitPrompt: 'Please review your information carefully before submit and any modification is not allowed after submitted\n',
		infoConfirm: "Confirm Information ",
		"getBack": "Back to revise",
		"Review": "Review",
		"applySuccess": "Your registration information submitted successfully and please wait for review",
		"join": "Yes",
		"unjoin": "No",
		"appointmentTitle": "Event Appointment"
	},
	applyJourney: {
		ji_ben_xin_xi: 'Basic Information',
		hui_yi_jiu_dian_xin_xi: 'Conference Hotel Information',
		title: 'Arrival Information',
		chu_fa_di: 'From Country/Region',
		di_zhi: 'Address',
		jiudian: 'Huatian Hotel, No.300 Jiefang East Road, Changsha City',
		ding_fang_dian_hua: 'Room Reservation',
		xiang_xi_di_zhi: 'Address',
		di_da_zhan_dian: 'Arrive at',
		di_da_ri_qi: 'Date of Arrival',
		fan_chen_xin_xi: 'Departure',
		jiao_tong_gong_ju: 'Vehicle',
		fan_chen_hang_ban: 'Departure Fight/High Speed Rail  No.',
		di_da_hang_ban: 'Arrival Fight/High Speed Rail  No.',
		fan_chen_zhan_dian: 'Departure From',
		fan_chen_ri_qi: 'Date of Departure',
		dizhi: 'City',
		xuanze_riqi: 'Please select a date',
		xiang_xi_di_zhi_rules: 'Please enter detailed address',
		di_da_hang_ban_rules: 'please enter Flight/High Speed Rail No.',
		fan_chen_hang_ban_rules: 'please enter Flight/High Speed Rail No.',
		hang_ban_rules: ' Plese enter Flight /High Speed Rail No.',
		// submitSucceed: 'Your information submitted successfully and if any request to amend,please update new itinerary information',
		submitSucceed:'Your information submitted successfully',
		inform: 'Please fill in the itinerary information before the meeting or your attendance will be bothered',
		bao_ming_ren_yuan: 'Name',
		shouji: 'Telephone No',
		bao_ming: 'Enroll Now',
		registration_ends:'Registration Ends',
		zhu_su_xin_xi: 'Hotel Information',
		shi_fou_xu_yao_zhu_su: 'If Hotel Service Required',
		fang_xing: 'Room Type',
		fu_fei_qing_kuang: 'Select payment option',
		ru_zhu_shi_jian: 'Check-in Time',
		li_dian_shi_jian: 'Check-out Time',
		shi_fou_xu_yao_jie_ji: 'If Pickup Services Required',
		di_da_shi_jian: 'Time of Arrival',
		fan_chen_shi_jian: 'Departure Time',
		bei_zhu: 'Notes',
		xuan_ze_shi_jian: 'Please select the time',
		jie_dao: 'Please enter your location’s street',
		shu_ru_bei_zhu: 'please input notes',
		lun_tan_guan_wang: 'Forum Official Website'
	},
	applyHealth: {
		bigTitle: "Health Declaration Form",
		title1: "1、If you have a history of traveling to overseas, Hongkong, and Taiwan areas within the last 28 days?",
		title11: "If yes, please clarify countries(regions)\n",
		title12: "Date of Entry",
		title2: "2、If you have a history of traveling to countries(regions) with low and high risks of Covid-19 within the last 14 days ? \n",
		title3: "3、If you have a history of traveling to cities with low and high risks of Covid-19 within the last 14 days ? ",
		title31: "If yes, Please clarify cities ",
		title32: "Please enter the last time when you leave city with risk of Covid-19\n",
		title4: "4、If you have interacted or conducted any physical contact with family members and friends who are from city with low and high risks of Covid-19 within the last 14 days? \n",
		title5: "5、If you have interacted or conducted any physical contact with the person  with the status of Suspected patient for Covid-19 and fever within the last 14 days?\n：",
		title6: "6、Whether a family member or friend of yours has a fever or contracted pneumonia or other diseases within the last 14 days?",
		title7: "7、Whether you have been proven positive or asymptomatic patient for Covid-19?",
		title8: "8、Are you currently experiencing, or have you experienced in the past 14 days, any of the following symptoms?",
		"无": "No",
		"发热": "fever",
		"咳嗽": "cough",
		"寒战": "chills",
		"鼻塞": "rhinobyon",
		"流涕": "runny nose",
		"咽痛": "sore throat",
		"头痛": "headache",
		"嗅（味）觉减退": "new loss of taste or smell",
		"乏力": "fatigue",
		"肌肉酸痛": "muscle ache",
		"关节酸痛": "body ache",
		"胸闷": "persistent pain or pressure in the chest",
		"气促呼吸困难": "shortness of breath or difficulty breathing",
		"结膜充血": "conjunctival injection",
		"恶心": "sick",
		"呕吐": "vomiting",
		"腹泻": "diarrhea",
		"腹痛": "bellyache",
		title81: "Or if you have other physical symptoms, please add：\n",
		title9: "9、Nucleic Acid Testing",
		"阴性": "Negative",
		"阳性": "Positive",
		title91: "Date of Test",
		title10: "10、Health QR Code",
		"绿色": "Green",
		"黄色": "Yellow",
		"红色": "Red",
		title101: " 11、Travel History Records",
		title1011: "I don’t have a history of traveling to cities that labeled with “*”\n",
		title1012: "I have a history of traveling to cities that labeled with “*”\n",
		fill1: "Signature：",
		fill2: "Date：",
		"tips1": " I declare the truthfulness and veracity of the statements, and accept the responsibilities of Covid-19 prevention and control pursuant to the relevant laws and regulations.",
		"tips2": "After verification, I confirm that I don’t have any of the above related conditions",
		"confirm": "Please check the verify information check box",
		"pleaseFill": "Please fill in"
	},
	agendaTitle: 'Forum Agenda',
	expertTitle: 'Specialists Interview',
	pastVideoTitle: 'Previous Highlights',
	forumTitle: 'About Forum',
	HostByTitle: 'Host By',
	OrganizedByTitle: 'Organized By',
	ExecutivePartiesTitle: 'Executive Parties',
	OperatingPartiesTitle: 'Operating Parties',
	CoOrganizedPartiesTitle: 'Co-organized Parties',
	SpecialAcknowledgementTitle: 'Special Acknowledgement',
}
